import { IHousingObjectResponse } from '@/types';
import { StructuredData } from '@/types/structuredData';
import { PATHS } from '@/constants';
import { generateListingDetailSchema } from './generateListingDetailSchema';
import { generateFiltersSchema } from './generateFiltersSchema';

const BASE_URL = process.env.BASE_URL;

export const generateProjectDetailSchema = (data: IHousingObjectResponse): StructuredData[] => {
  const slug = data.slug || '';
  const slugLink = slug ? `${slug}__${data.id}` : data.id;
  const pageUrl = `${BASE_URL}/${PATHS.PROJECT}/${slugLink}`;

  return [generateListingDetailSchema(data, pageUrl), generateFiltersSchema(data)];
};
